AddPageSwapTrigger(function() {
   updateFooterPosition();
});

$(document).ready(function ($) {
    $(document).resize(updateFooterPosition);
});
